// extracted by mini-css-extract-plugin
export default {"Promo":"Promo_Promo__4ybN4"};